import React, {useContext} from 'react';
import {Grid} from '@material-ui/core';
import SelectField from '../../../../FormikUtils/SelectField'
import FormikAutocomplete from '../../../../FormikUtils/FormikAutocomplete'
import {Field} from "formik";
import CotizarContext from "../../../../../../context/CotizarContext";
import DependantField from "../../../../FormikUtils/DependantField";

export default function TitularForm(props) {
    const {localidades, afinidades} = useContext(CotizarContext)
    const {
        formField: {
            vehiculo: {
              usoVehiculo
            },
            situacionImpositiva,
            personaJuridica,
            codigosLocalidad,
            afinidad,
            zonaRiesgo
        },
    } = props;

    const situaciones_impositivas = [
        {value: '1', label: 'Responsable inscripto'},
        //{value: '2', label: 'Responsable no inscripto'},
        //{value: '3', label: 'Exento'},
        {value: '4', label: 'Consumidor final'},
        //{value: '5', label: 'No declarado'},
        //{value: '6', label: 'No alcanzado'},
        //{value: '7', label: 'Responsable monotributo'},
        //{value: '8', label: 'Sujeto no categorizado'},
    ];

    const opciones_binarias = [
        {value: '0', label: 'No'},
        {value: '1', label: 'Si'}
    ];

    const tipos_de_uso = [
        {value: '2', label: 'Particular'},
        {value: '4', label: 'Particular y/o Comercial'},
        {value: '7', label: 'Transporte General Rutero'}
    ];

    return (
        <React.Fragment>
            <Grid container spacing={3}>

                <Grid item xs={12} sm={12}>
                    <Field
                        name={afinidad.name}
                        label={afinidad.label}
                        component={FormikAutocomplete}
                        options={afinidades}
                        textFieldProps={{
                            label: afinidad.label,
                            required: true,
                        }}
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <SelectField
                        name={situacionImpositiva.name}
                        label={situacionImpositiva.label}
                        data={situaciones_impositivas}
                        fullWidth
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <SelectField
                        name={personaJuridica.name}
                        label={personaJuridica.label}
                        data={opciones_binarias}
                        fullWidth
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <Field
                        name={codigosLocalidad.name}
                        label={codigosLocalidad.label}
                        component={FormikAutocomplete}
                        options={localidades}
                        textFieldProps={{
                            label: codigosLocalidad.label,
                            required: true,
                        }}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <DependantField
                        options={localidades}
                        dependantField={zonaRiesgo}
                        dependsOn={codigosLocalidad}/>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <SelectField
                        name={usoVehiculo.name}
                        label={usoVehiculo.label}
                        data={tipos_de_uso}
                        fullWidth
                    />
                </Grid>
            </Grid>
        </React.Fragment>
    );
}
